import React, { useState, useEffect } from 'react';
import '../styles/papers.css';
import { useTranslation } from 'react-i18next';
import DataContext from '../contexts/DataContext';

const Papers = () => {
  const [filters, setFilters] = useState({
    area: '',
  });
  const [searchTerm, setSearchTerm] = useState('');
  const { t, i18n } = useTranslation('papers');
  const { people, papers, isLoading } = React.useContext(DataContext);

  const handleFilterChange = (filterName, value) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      [filterName]: value
    }));
  };

  const handleSearchTermChange = event => {
    setSearchTerm(event.target.value);
  };

  let filteredPapers = papers;
  filteredPapers = filteredPapers.filter(paper => {
    return (
      (filters.area === '' || paper.area === filters.area) &&
      ((paper.title && paper.title.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (paper.description && paper.description.toLowerCase().includes(searchTerm.toLowerCase())))
    );
  });

  if (isLoading) {
    return <div className="loading">{t('loading')}...</div>;
  }

  const renderMemberNames = (integrantes) => {
    if (!integrantes) return null;
    const authorNames = integrantes.map((integrante) => {
      const person = people.find(p => p.username === integrante);
      if (!person) {
        console.warn(`No se encontró a la persona con el identificador "${integrante}" en los datos de las personas.`);
        return null;
      }
      return person.display_name;
    });
    return authorNames.join(', ');
  };

  const renderCards = () => {
    return filteredPapers.map((paper, index) => (
      <div className="col-lg-12 col-md-12 mb-12" key={index}>
        <div className="card mw-100">
          <div className="card-contentt d-flex flex-sm-column flex-column flex-md-row">
            <div className="col-md-11 col-12">
              <div className="card-bodyy">
                <div className="d-flex justify-content-between">
                  <p className="card-date">{paper.date}</p>
                  <p className="card-authors">{renderMemberNames(paper.authors)}</p>
                </div>
                <h5 className="card-titlee">{paper.title}</h5>
                <p className="card-textt">{paper.description}</p>
                <div className="card-end d-flex justify-content-between">
                  <div className="d-flex">
                    <p className="card-research text-grey">{t('category')}: {paper.area}</p>
                  </div>
                  <a href={paper.link} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                    {t('read-more')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div className="papers container">
      <h1>{t('title')}</h1>
      <div className="filters">
        <select value={filters.researchArea} onChange={e => handleFilterChange('area', e.target.value)}>
          <option value="">{t('nav-option-1')}</option>
          <option value="Human Computer Interaction">{t('nav-option-2')}</option>
          <option value="Image Processing">{t('nav-option-3')}</option>
          <option value="Mixed Realities">{t('nav-option-4')}</option>
          <option value="Robotics">{t('nav-option-5')}</option>
          <option value="Visual Analytics">{t('nav-option-6')}</option>
          <option value="Video Games">{t('nav-option-7')}</option>
        </select>
        <input
          type="text"
          placeholder={t('placeholder')}
          value={searchTerm}
          onChange={handleSearchTermChange}
        />
      </div>
      <div className="row d-flex align-items-stretch">
        {renderCards()}
      </div>
    </div>
  );
};

export default Papers;
